import React, { useEffect, useState } from "react";
import {
    Container, Typography, Paper, CssBaseline, Snackbar,
    Alert,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";

import ResetPasswordForm from "../forms/ResetPasswordForm";
import { useResetPassword } from "../../hooks/authHooks";

const ResetPassword = () => {
    const { uid, token } = useParams();
    const navigate = useNavigate();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("failure");

    const onSuccess = () => {
        navigate("/");
    };

    const onFailure = (error) => {
        setSnackbarMessage("Email verification failed. Please try again later.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
    };

    const {
        mutate: resetPassword,
        isPending: isResettingPassword,
        error: resetPasswordError,
        data: resetPasswordData,
    } = useResetPassword({onSuccess, onFailure});

    const handleResetPassword = (data) => {
        resetPassword({ uid, token, ...data });
    };

    useEffect(() => {
        if (resetPasswordData) {
            // console.log("Reset Password Data: ", resetPasswordData);
            navigate("/");
        }
    }, [resetPasswordData]);

    useEffect(() => {
        if (resetPasswordError) {
            // console.log("Reset Password Error: ", resetPasswordError);
        }
    }, [resetPasswordError]);

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
                <Typography component="h1" variant="h5" sx={{ textAlign: "center", mb: 3 }} >
                    Enter New Password
                </Typography>
                <ResetPasswordForm handleResetPassword={handleResetPassword} />
            </Paper>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Container>
    );

};

export default ResetPassword;